/** Empty list message */
export function ListEmpty({ message = "Нет данных" }) {
  return <div className="list-empty">{message}</div>;
}
